/* global jQuery */
(function ($) {
    $(document).ready(function () {
        $('.dropdown-selector').change(function () {
            window.location.href = $(this).find('option:selected').val();
        });
    });
})(jQuery);